<template>
  <div>
    <div class="container-fluid m-0 p-0">
      <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
        <div class="col-sm-12 h-100 my-auto p-0 m-0">
          <span class="mx-3 font-weight-bold lead">Announcement</span>
          <span class="mx-3">
            <router-link
              :to="{ name: 'AnnouncementCreate' }"
              tag="button"
              class="btn btn-sm btn-outline-primary font-weight-bolder"
              title="Add New User Record"
            >
              <span class="fas fa-user-plus"></span>
              Add Announcement
            </router-link>
          </span>
          <span class="float-right py-1 mx-2 pr-4">
            <button
              class="btn btn-xs btn-outline-secondary px-2 mr-1"
              title="Go to Previous Page"
              @click="goBack"
            >
              <span class="fas fa-backward"></span>
              Go Back
            </button>
          </span>
        </div>
      </div>
      <div class="row text-small">
        <div class="col col-md-12" v-show="!announcements.length">
            <h5 class="mt-5">
                No announcements available
            </h5>
        </div>
        <div class="col col-md-12" v-show="announcements.length">
          <table
            class="table table-hover table-bordered table-template-1 my-2 text-small"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Message</th>
                <th>Announcement Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(announcement, index) in announcements"
                :key="announcement.id"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ announcement.message }}</td>
                <td>{{ announcement.announcement_type.name }}</td>
                <td>{{ announcement.start_date }}</td>
                <td>{{ announcement.end_date }}</td>
                <td>
                  <router-link
                    :to="{
                      name: 'AnnouncementEdit',
                      params: { id: announcement.id },
                    }"
                    class="btn btn-sm btn-outline-warning"
                  >
                    <span class="fa fa-pencil"></span>
                    Edit
                  </router-link>
                  <button
                    class="ml-1 btn btn-outline-danger btn-sm"
                    @click="deleteAnnouncements(announcement.id)"
                  >
                    <span class="fa fa-trash"></span>
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { mapState, mapGetters, mapActions } from "vuex";
import { GlobalService } from "@/services/GlobalService";

export default {
  computed: {
    ...mapState({
      announcements: (state) => {
        return state.AnnouncementModule.announcements;
      },
    }),
  },
  created() {
    this.fetchAnnouncements();
  },
  methods: {
    async fetchAnnouncements() {
      this.$store.dispatch("AnnouncementModule/fetchAnnouncements");
    },
    async deleteAnnouncements(id) {
      let self = this;

      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
            self.$store.dispatch("AnnouncementModule/deleteAnnouncement", id).then(() => {
                self.fetchAnnouncements()
            })
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped></style>
